export enum AssetType {
  Solar = 'Solar',
  Wind = 'Wind',
  Generator = 'Generator',
  EVChargingStation = 'EV Charging Station',
  StreetLight = 'Street Light',
  PublicAreaLighting = 'Public Area Lighting (Parking Lot, Pathway)',
  BatteryEnergyStorageSystem = 'Battery Energy Storage System (BESS)',
  MicroMobilityChargingDock = 'Micro-Mobility Charging Dock (e-bikes, e-scooters)',
  CombinedHeatAndPower = 'CHP (Combined Heat and Power)',
  PowerSubstation = 'Power Substation',
  DieselVehicle = 'Diesel Vehicle',
  HybridVehicle = 'Hybrid Vehicle',
  ElectricVehicle = 'Electric Vehicle',
  HydrogenFuelCellVehicle = 'Hydrogen Fuel Cell Vehicle',
  FuelDispensingPoint = 'Fuel Dispensing Point',
  HydrogenFuelingStation = 'Hydrogen Fueling Station',
  FleetChargingDepot = 'Fleet Charging Depot',
  VirtualPowerPurchaseAgreement = 'Virtual Power Purchase Agreement',
  SignalAndCommunicationsEquipment = 'Signal and Communications Equipment',
}
